import { useMessageNotifications } from "@/hooks/useMessageNotifications";
import { useAuth } from "@/hooks/useAuth";
import MessageNotification from "@/components/MessageNotification";

export const GlobalMessageNotifications = () => {
  const { user } = useAuth();
  const { notification, dismissNotification } = useMessageNotifications();

  if (!user || !notification) return null;

  return (
    <MessageNotification
      senderName={notification.senderName}
      senderAvatar={notification.senderAvatar}
      message={notification.message}
      chatId={notification.chatId}
      onDismiss={dismissNotification}
    />
  );
};

export default GlobalMessageNotifications;
